import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sot-recommendationDish',
  templateUrl: './recommendationDish.component.html',
  styleUrls: ['./recommendationDish.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationDishComponent {
  @Input() title: string;
  @Input() has_image: boolean;
  @Input() image: string;
  @Input() price: number;
  @Input() available: boolean;
  @Input() schedule_active: boolean;
  @Input() schedule_hint: string;

  public constructor() {
  }
}

